<ul class="profile-nav-menu">
  <li>
    <button class="user-profile-button" mat-icon-button [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger">
      <mat-icon class="user-profile-icon open-sans icon-color">
        {{profileImg}}
      </mat-icon>
    </button>
    <mat-menu #menu="matMenu" [overlapTrigger]="false">
      <div class="menu-panel">
        <div class="pt-2 pb-2 pl-3">
          <span class="menu-label" [innerHTML]="loginUserName"></span>
        </div>
        <ng-container *ngFor="let menu of profileMenu">
          <button mat-menu-item (click)="performAction(menu.LinkUrl)" style="outline: none">
            <mat-icon class="menu-item-icon">{{menu.ImageName}}</mat-icon>
            <span [innerHTML]="menu.Caption"></span>
          </button>
          <mat-divider></mat-divider>
        </ng-container>
      </div>
    </mat-menu>
  </li>
</ul>
